// Global cart state manager — survives any DOM replacement
window.CartHeaderState = {
  itemCount: 0,
  totalText: '',
  observer: null,

  init() {
    // Start observing immediately
    this.startObserving();
  },

  update(itemCount, totalText) {
    this.itemCount = itemCount;
    this.totalText = totalText;
    this.applyToDOM();
  },

  applyToDOM() {
    const shoppingDetails = document.querySelector('.shopping-details');
    const countBubble = document.querySelector('.cart-count-bubble');
    const cartPrice = document.querySelector('.cart-shopping-details');

    if (!shoppingDetails) return;

    if (this.itemCount > 0) {
      shoppingDetails.classList.remove('hidden');
      if (countBubble) {
        countBubble.innerHTML = `
          <span aria-hidden="true">${this.itemCount}</span>
          <span class="visually-hidden">${this.itemCount} items</span>
        `;
      }
      if (cartPrice && this.totalText) {
        cartPrice.textContent = this.totalText;
      }
    } else {
      shoppingDetails.classList.add('hidden');
      if (countBubble) countBubble.innerHTML = '';
    }
  },

  startObserving() {
    if (this.observer) this.observer.disconnect();

    // Watch the entire header for any DOM changes
    const header = document.querySelector('.section-header') || document.querySelector('header') || document.body;

    this.observer = new MutationObserver(() => {
      // Re-apply cart state after any DOM change in header
      if (this.itemCount > 0) {
        // Use requestAnimationFrame to run after all current DOM operations complete
        cancelAnimationFrame(this._rafId);
        this._rafId = requestAnimationFrame(() => {
          this.applyToDOM();
        });
      }
    });

    this.observer.observe(header, { childList: true, subtree: true });
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.CartHeaderState.init();
});